import * as yup from "yup";
import { useTranslation } from "react-i18next";

export const appl21ValidationSchema = () => {
  const { t } = useTranslation();
  return yup.object().shape({
    d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    balanceSheetYear: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    balanceSheetMonth: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    fudocBalanceSheet: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
  });
};
